import * as UserStore from './UserStore';
import * as AccountStore from './AccountStore';
import * as AppealListStore from './AppealListStore';
import * as GuideStore from './GuideStore';
import * as UserNotificationStore from './UserNotificationStore';




export interface ApplicationState {
    user: UserStore.UserState | undefined;
    AccountState: AccountStore.AccountStateState | undefined;
    appealList: AppealListStore.AppealListState | undefined;
    guide: GuideStore.GuideState | undefined;
    userNotification: UserNotificationStore.UserNotificationState | undefined;

}

export const reducers = {
    AccountState: AccountStore.reducer,
    appealList: AppealListStore.reducer,
    guide: GuideStore.reducer,
    user: UserStore.reducer,
    userNotification: UserNotificationStore.reducer,

};

export interface AppThunkAction<TAction> {
    (dispatch: (action: TAction) => void, getState: () => ApplicationState): void;
}
